module.exports = __webpack_public_path__ + "media/images/wines/tempranillo-rosado/bottle-40817befd7e8ff80cb927f200898dd8b.png";